import React from 'react';
import Text from '../components/Text';
import { Link, useNavigate } from "react-router-dom";


function Nopage(props) {
    return (
        <div className='w-splashscreen w-fullscreen '>
            <img className="w-img-lg" src="/img/categories/wordin_full.png" alt="login" />
            
            <Text text="404" classes="w-text-blue-xxl" />
            <br />
            <br />
            <br />
            <Link to="/home">
                <Text text="Pas de correspondance ? Revenir à l’accueil." classes="w-text-black-m" />
            </Link>
        </div>
    );
}

export default Nopage;